// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

import Cookies from 'js-cookie';
import { getAdminModule } from '@/utils/settingMer';
var TokenKeys = {
  platform: 'Java-platformToken',
  business: 'businessToken',
  region: 'regionToken'
};
function getTokenKey() {
  return TokenKeys[getAdminModule()] || TokenKeys.platform;
}
export function getToken() {
  return Cookies.get(getTokenKey());
}
export function setToken(token) {
  return Cookies.set(getTokenKey(), token);
}
export function removeToken() {
  return Cookies.remove(getTokenKey());
}